import React from 'react';
import { router } from 'expo-router';
import { Text, TextInput, Button, HelperText } from 'react-native-paper';
import { View, Image, Platform, Keyboard } from 'react-native';
import axios from 'axios';
import { useSession } from '../ctx/ctx';
import { MainContext } from '../contexts/MainContext';
import Logo from '../assets/logo.png';

export default function SignIn() {
  const { signIn } = useSession();
  const [mobile, setMobile] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [mobileCheck, setMobileCheck] = React.useState(false);
  const [requestLoading, setRequestLoading] = React.useState(false);
  const myContext = React.useContext(MainContext);

  const mobileNumberCheck = (number) => {
    setMobile(number);
    if(/^(\98|98|0)?09\d{09}$/g.test(number)) {
      setMobileCheck(false);
    } else {
      setMobileCheck(true);
    }
  }

  const sendOtpCode = async (mobile) => {
    setRequestLoading(true);
    await axios.post(`/full-login`, {phone: mobile, email: email, password: password})
      .then((response) => {
        if(response.data.status) {
          signIn(response.data.token);
          setTimeout(() => {
            router.replace('/');
          }, 500);
          myContext.setUserData(response.data.user);
          myContext.activateSnackbar(true, response.data.message);
          axios.defaults.headers.common['Authorization'] = "Bearer " + response.data.token;
          axios.defaults.baseURL = `https://40lsoton.ir/api`;
          axios.defaults.headers.common['Cache-Control'] = 'no-cache';
          axios.defaults.headers.common['Pragma'] = 'no-cache';
          axios.defaults.headers.common['Expires'] = '0';
          setRequestLoading(false);      
        } else {
          myContext.activateSnackbar(true, response.data.message);  
          setRequestLoading(false); 
        }
      })
      .catch(myContext.handleAxiosError)
      .finally(() => setRequestLoading(false));
  }
  
  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff', paddingHorizontal: 18 }}>
      <View style={{ justifyContent: 'center', alignItems: 'center', marginBottom: 100, marginTop: 100 }}>
        <Image style={{width: 140, height: 101}} source={Logo} />
        <Text style={{fontSize: 16, fontFamily: 'IRANSans', marginTop: 12 }}>پنل مشاوران</Text>
      </View>
      <View>
        <Text style={{fontSize: 16, textAlign: Platform.OS === 'web' ? 'right' : 'left', fontFamily: 'IRANSans', marginBottom: 8, direction: 'rtl'}}>شمارۀ موبایل</Text>
        <Text style={{fontSize: 12, textAlign: Platform.OS === 'web' ? 'right' : 'left', fontFamily: 'IRANSans', marginBottom: 24, direction: 'rtl'}}>کارشناس 40 ستون عزیز لطفا برای ورود به سیستم خود شماره موبایل ثبت شده در سامانه را وارد کنید.</Text>
        <View>
          <TextInput
            label="شمارۀ موبایل"
            placeholder="شمارۀ موبایل خود را وارد کنید"
            mode="outlined"
            error={mobileCheck}
            style={{ fontSize: 14, width: '100%', direction: Platform.OS === 'web' ? 'rtl' : 'ltr' }}
            maxLength={11}
            value={mobile}
            activeOutlineColor="#c6c5c4"
            keyboardType='number-pad'
            onChangeText={text => {mobileNumberCheck(text); if(text.length === 11) {Keyboard.dismiss()} }}
          />
          <TextInput
            label="ایمیل"
            placeholder="ایمیل خود را وارد کنید"
            mode="outlined"
            style={{ fontSize: 14, width: '100%', direction: Platform.OS === 'web' ? 'rtl' : 'ltr' }}
            value={email}
            activeOutlineColor="#c6c5c4"
            keyboardType='email-address'
            onChangeText={text => {setEmail(text); }}
          />
          <TextInput
            label="رمز عبور"
            placeholder="رمز عبور خود را وارد کنید"
            mode="outlined"
            style={{ fontSize: 14, width: '100%', direction: Platform.OS === 'web' ? 'rtl' : 'ltr' }}
            value={password}
            activeOutlineColor="#c6c5c4"
            keyboardType='default'
            onChangeText={text => {setPassword(text); }}
          />
        </View>
        <HelperText type="error" visible={mobileCheck}>لطفا شماره موبایل را بدرستی وارد کنید</HelperText>
        <Button disabled={mobileCheck} loading={requestLoading} labelStyle={{ fontSize: 16 }} style={{ marginTop: 36, borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} mode="contained" onPress={() => sendOtpCode(mobile)}>ورود</Button>
        <Text style={{ fontSize: 12, textAlign: 'center', color: '#999897', marginTop: 16 }}>با ورود و یا ثبت نام در 40 ستون شما <Text style={{ color: '#2b93f3' }}>شرایط و قوانین</Text> استفاده از سرویس‌های سایت 40 ستون و <Text style={{ color: '#2b93f3' }}>قوانین حریم خصوصی</Text> آن را میپذیرید.</Text>
      </View>
    </View>
  );
}
